// @flow
import React from 'react';
import { connect } from 'react-redux';
import { reduxForm, Field } from 'redux-form';
import { MdSearch } from 'react-icons/lib/md';
import { Row, Col, Grid } from 'react-flexbox-grid';
import i18n from 'i18n-js';

import styles from './reportTopForm.css';
import { onSubmit, validate } from './utils';
import { RenderDateRangePicker, RenderTypeahead } from '../../FieldRenderer';
import OmnisearchLoadingResults from '../../OmnisearchLoadingResults';
import { OMNISEARCH_RESULT_TYPES } from '../../Omnisearch';
import CloseableInputSearchResult from '../../CloseableInputSearchResult';
import OmnisearchResult from '../../OmnisearchResult';
import * as selectors from '../../../reducers';
import { generateFetcher } from '../../Omnisearch/utils';
import { Search } from '../../CommonTexts';
import { getUserImage } from '../../../utils';


type ReportTopFormPropTypes = {
  name: string,
  fetchElements: Function,
  handleSubmit: Function,
  selected: string,
};
const customRenderSelected = (item, onClear) => {
  switch (item.result_type) {
    case OMNISEARCH_RESULT_TYPES.student: {
      return (
        <CloseableInputSearchResult
          title={`${item.first_name} ${item.last_name}`}
          subtitle={i18n.t('labels.students', { count: 1 })}
          closeAction={onClear}
          pictureURL={getUserImage(item.profile_picture)}
        />
      );
    }

    case OMNISEARCH_RESULT_TYPES.routeStop: {
      return (
        <CloseableInputSearchResult
          title={`${item.name} - ${item.short_name}`}
          subtitle={i18n.t('labels.stops')}
          closeAction={onClear}
        />
      );
    }

    case OMNISEARCH_RESULT_TYPES.route: {
      return (
        <CloseableInputSearchResult
          title={`${item.name}`}
          subtitle={i18n.t('labels.route', { count: 1 })}
          closeAction={onClear}
        />
      );
    }
    default: return null;
  }
};

const customRenderItem = (item: Object, isHighlighted: boolean) => (
  <OmnisearchResult
    {...item}
    isSelected={isHighlighted}
    size="small"
  />
);

const deductFetcher = (key: string, schoolId, token) => {
  let result;
  if (key === 'student_profile') {
    result = generateFetcher(
      OMNISEARCH_RESULT_TYPES.student,
      schoolId,
      token,
    );
  } else if (key === 'route') {
    result = generateFetcher(
      OMNISEARCH_RESULT_TYPES.route,
      schoolId,
      token,
      {
        short_name: true,
      },
    );
  }
  return result;
};
const ReportTopForm = (props: ReportTopFormPropTypes) => {
  const {
    fetchElements,
    handleSubmit,
    onSubmit,
  } = props;
  return (
    <form
      id='createReport'
      className={styles.reportTopForm}
    >
      <Grid>
        <Row className={styles.topFormRow}>
          <Col xs={5} middle="xs">
            <Field
              name="selectedElement"
              component={RenderTypeahead}
              inputDebounce={200}
              renderSelectedValue={customRenderSelected}
              renderLoading={() => <OmnisearchLoadingResults size="small" count={3} />}
              fetchItems={fetchElements}
              customOnChange={() => {
                const submitter = handleSubmit(onSubmit);
                submitter();// submits
              }}
              renderItem={customRenderItem}
                // onChange={onChangeSubmit(user.onChange, onSubmit)}
              inputProps={{
                Icon: MdSearch,
                iconPosition: 'right',
                placeholder: Search(i18n.t('reports.element'), 1),
              }}
            />
          </Col>
          <Col xs={7}>
            <Row end="sm">
              <Field
                name="date_range"
                component={RenderDateRangePicker}
                renderItem={customRenderItem}
                isOutsideRange={() => false}
                anchorDirection="right"
                customOnChange={(val) => {
                  setTimeout(() => {
                    const submitter = handleSubmit(onSubmit);
                    submitter();// submits
                  }, 1000);
                }}
              />
            </Row>
          </Col>
        </Row>
      </Grid>
    </form>
  );
};

export default connect(
  (state, { report }) => {
    const schoolId = (selectors.getProfileOfType(state, 'admin') || {}).school || -1;
    const token = selectors.getToken(state);
    const fetchElements = deductFetcher(report.form_selector, schoolId, token);
    return {
      schoolId,
      fetchElements,
    };
  },
  undefined,
)(reduxForm({
  form: 'createReport',
  onSubmit,
  validate,
})(ReportTopForm));



// WEBPACK FOOTER //
// ./src/scripts/components/ReportDisplay/ReportTopForm/index.jsx